import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: { marginTop: theme.spacing(1), marginBottom: theme.spacing(1) },
  planName: { fontWeight: 'bold' },
}));

export default function ExistingPlan({ planName }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography gutterBottom>
        These Lines will be included in the following plan:
      </Typography>
      <Typography variant="h5" className={classes.planName}>
        {planName}
      </Typography>
    </div>
  );
}
